import { ColumnHeader, Table, TableColumn, TableRow, ThresholdPill } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import ContentConstants from '../../../contentConstants';
import { IBenchmark, IColumn, ISurveyBuilderActionCreators, SurveyStep } from '../../../models';
import { ISurveyBuilderState } from '../../../store/SurveyBuilderStore';
import { ColumnHelper } from '../../../utilities';
import { ClearDiv, Col3Col9, NoSearchResultsMessage, Section } from '../../common';
import { BodyCopyLink } from '../../common/styles/globalStyles';

export type IReportingBenchmarksProps = ISurveyBuilderActionCreators &
	ISurveyBuilderState & {
		benchmarks: IBenchmark[];
	};

export class ReportingBenchmarks extends React.PureComponent<IReportingBenchmarksProps> {
	private columns: IColumn[] = [
		{
			name: 'name',
			displayText: ContentConstants.TABLE_HEADER_REPORTING_NAME,
			checked: true,
			displayOrder: 2,
			disabled: false,
		},
		{
			name: 'description',
			displayText: ContentConstants.TABLE_HEADER_REPORTING_DESCRIPTION,
			checked: true,
			displayOrder: 1,
			disabled: false,
		},
	];

	constructor(props: IReportingBenchmarksProps) {
		super(props);

		this.jumpTo = this.jumpTo.bind(this);
	}

	public render() {
		const { benchmarks } = this.props;

		return (
			<Section id={ContentConstants.ID_REPORTING_BENCHMARKS} sectionHeader={ContentConstants.SECTIONHEADERS_REPORTING_SETUP_BENCHMARKS}>
				<Col3Col9 label={ContentConstants.SUBSECTIONHEADERS_BENCHMARKS} subLabelDisplayData={<ThresholdPill count={benchmarks.length} />}>
					<div>
						{ContentConstants.INSTRUCTIONALTEXT_REPORTING_BENCHMARKS}
						<BodyCopyLink onClick={() => this.jumpTo(SurveyStep.Basics)}>
							{ContentConstants.INSTRUCTIONALTEXT_REPORTING_BENCHMARKS_BACK_LINK}
						</BodyCopyLink>
						.
					</div>
				</Col3Col9>
				<ClearDiv />
				<Col3Col9>
					{benchmarks.length > 0 && (
						<Table responsive={true}>
							<ColumnHeader columns={ColumnHelper.GetColumnHeaders(this.columns)} />
							<tbody>
								{benchmarks.map((benchmark: IBenchmark, index) => (
									<TableRow key={index} record={benchmark.benchmarkId}>
										<TableColumn>{benchmark.displayText}</TableColumn>
										<TableColumn>{benchmark.description}</TableColumn>
									</TableRow>
								))}
							</tbody>
						</Table>
					)}
					{benchmarks.length === 0 && (
						<NoSearchResultsMessage message={ContentConstants.REPORTING_NO_BENCHMARKS_SELECTED} textAlign={'left'} />
					)}
				</Col3Col9>
			</Section>
		);
	}

	public jumpTo(surveyStep: SurveyStep) {
		const { surveyId } = this.props;
		if (surveyId !== undefined && surveyId !== 0) {
			this.props.Jump(surveyStep);
		}
	}
}
